<div class="mt-8 mb-4">

    <div class="flex flex-row justify-between w-full mb-4">

        @let group = group$ | async;
        @let myRoles = myRoles$ | async;

        <app-btn-back></app-btn-back>
    </div>

    <div class="mb-4 border-0 w-full">

        <h1 class="font-semibold text-2xl text-blueGray-700 mb-4">
            Quiz Home
        </h1>

        @if (group?.memberStatus == membershipStatus.active && (myRoles?.management || myRoles?.faculty)) {
        <div class="flex flex-row justify-end gap-4 w-full mb-4">
            <app-btn-route routeTo="addQuestions" colors="bg-transparent"
                textColor="text-primary-300 hover:text-primary-500" textStyle="text-sm titlecase" [shadow]="false"
                icon="fa fa-add" btnText="Add Question(s)"></app-btn-route>
            <app-btn-route routeTo="questionbank" colors="bg-transparent" textStyle="text-sm titlecase"
                textColor="text-primary-300 hover:text-primary-500" icon="fa fa-layer-group" [shadow]="false"
                btnText="Question Bank"></app-btn-route>
        </div>
        }

        @let stats = stats$ | async;
        @let loadingStats = loadingStats$ | async;

        @if (group?.memberStatus == membershipStatus.active && (myRoles?.management || myRoles?.faculty)) {
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-4 w-full">
            <div
                class="col-span-1 bg-white border border-gray-300 rounded-lg shadow-lg px-4 py-2 flex flex-col gap-2 justify-between">
                <div class="flex flex-row justify-between">
                    <span class="flex w-full items-center text-start text-sm text-gray-400">Active Quizzes</span>
                    <btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshStats()" textColor="text-gray-300"
                        textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <span class="text-5xl text-right font-bold text-primary-500">{{ (stats?.quizTypes?.scheduled ??
                    0) + (stats?.quizTypes?.live ?? 0) }}</span>
                }
            </div>
            <div
                class="col-span-1 bg-white border border-gray-300 rounded-lg shadow-lg px-4 py-2 flex flex-col gap-2 justify-between">
                <div class="flex flex-row justify-between">
                    <span class="flex w-full items-center text-start text-sm text-gray-400">Question Bank</span>
                    <btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshStats()" padding="" textColor="text-gray-300"
                        textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <span class="text-5xl text-right font-bold text-primary-500">
                    {{ stats?.totalQuestions ?? '-' }}</span>
                }
            </div>
            <div
                class="col-span-2 bg-white border border-gray-300 rounded-lg shadow-lg px-4 py-2 flex flex-col justify-between">
                <div class="flex flex-row justify-between mb-2">
                    <span class="flex w-full items-center text-start text-sm text-gray-400">Question Types</span>
                    <btn-icon [icon]="'fas fa-refresh'" (onClick)="refreshStats()" textColor="text-gray-300"
                        textHoverColor="text-primary-500"></btn-icon>
                </div>
                @if (loadingStats) {
                <div class="animate-pulse h-6 bg-slate-200 rounded w-1/2 ml-auto"></div>
                } @else {
                <div class="flex flex-row justify-between px-4 py-1 rounded-md bg-gray-100 mb-0.5">
                    <span class="text-sm text-gray-500">Multiple Choice</span>
                    <span class="text-sm text-right font-bold text-primary-500">{{ stats?.questionTypes?.multipleChoice
                        ??
                        0 }}</span>
                </div>
                <div class="flex flex-row justify-between px-4 py-1 rounded-md bg-gray-100 mb-0.5">
                    <span class="text-sm text-gray-500">Fill In The Blank</span>
                    <span class="text-sm text-right font-bold text-primary-500">{{ stats?.questionTypes?.fillInTheBlank
                        ??
                        0 }}</span>
                </div>
                <div class="flex flex-row justify-between px-4 py-1 rounded-md bg-gray-100 mb-0.5">
                    <span class="text-sm text-gray-500">True/False</span>
                    <span class="text-sm text-right font-bold text-primary-500">{{ stats?.questionTypes?.trueFalse
                        ??
                        0 }}</span>
                </div>
                <div class="flex flex-row justify-between px-4 py-1 rounded-md bg-gray-100 mb-0.5">
                    <span class="text-sm text-gray-500">Short Answer</span>
                    <span class="text-sm text-right font-bold text-primary-500">{{ stats?.questionTypes?.shortAnswer
                        ??
                        0 }}</span>
                </div>
                }
            </div>
        </div>
        }

        @let quizzes = quizzes$ | async;
        <div class="col-span-full row-span-2 flex flex-col justify-start mt-4">
            @if (group?.memberStatus === membershipStatus.active && (myRoles?.management || myRoles?.faculty)) {
            <div class="flex flex-row items-center mb-4 justify-between">
                <span class="flex w-full items-center text-start text-md font-semibold text-primary-400">All
                    Quizzes</span>
                @if(quizzes && quizzes.length > 0) {
                <div class="flex flex-row gap-4 items-center justify-around mt-1">
                    <app-btn-route routeTo="scheduleQuiz" colors="bg-transparent" padding="px-2 py-1"
                        textColor="text-primary-300 hover:text-primary-500" textStyle="text-xs" [shadow]="false"
                        icon="fa fa-calendar-day" btnText="Schedule Quiz"></app-btn-route>
                    <app-btn-route routeTo="createLiveQuiz" colors="bg-transparent" padding="px-2 py-1"
                        textColor="text-primary-300 hover:text-primary-500" textStyle="text-xs" [shadow]="false"
                        icon="fa fa-play" btnText="Live Quiz Room"></app-btn-route>
                </div>
                }
            </div>
            }
            @for (item of quizzes; track $index) {
            <div (click)="routeQuiz(item)"
                class="relative flex flex-col flex-wrap gap-1 w-full bg-white border border-gray-300 rounded-md shadow-sm px-4 py-2 mb-2 justify-between items-center cursor-pointer hover:bg-gray-100">

                <div class="flex flex-row flex-wrap w-full items-center justify-between">
                    <!-- Left side: Date, Chips, and Status -->
                    <div class="flex flex-row flex-wrap items-center gap-2">
                        <span class="flex items-center text-xs text-primary-300">
                            {{ item.scheduledAt | moment : 'Do MMM YYYY' }}
                        </span>
                        <app-chip class="font-mono inline-flex items-center"
                            [label]="item.byInvite ? 'By Invite': 'For All'"
                            [prefixIcon]="item.byInvite ? 'fa fa-lock': 'fa fa-unlock'" fontSize="text-[9px]"
                            padding="py-0.5 px-1" [color]="item.byInvite ? chipColor.DANGER : chipColor.SUCCESS">
                        </app-chip>
                        <app-chip class="font-mono inline-flex items-center" [label]="item.isLive ? 'Live': 'Scheduled'"
                            [prefixIcon]="item.isLive ? 'fa fa-play': 'fa fa-calendar'" fontSize="text-[9px]"
                            padding="py-0.5 px-1" [color]="item.isLive ? chipColor.WARNING : chipColor.INFO">
                        </app-chip>

                        <div class="flex flex-row gap-1 items-center ml-2">
                            @let live = (item.quizStatus === 'inProgress' || item.quizStatus === 'waiting') &&
                            item.isLive;
                            @let scheduled = (item.quizStatus === 'scheduled') && (!item.isLive);
                            @let draft = item.quizStatus === 'draft';

                            <span class="relative flex items-center justify-center size-2">
                                <span
                                    class="absolute inline-flex h-full w-full rounded-full opacity-75 {{ live ? 'animate-ping bg-red-400' : scheduled ? 'bg-blue-400' : draft ? 'bg-yellow-400' : 'bg-gray-400' }}"></span>
                                <span
                                    class="relative inline-flex rounded-full size-2 {{ live ? 'bg-red-500' : scheduled ? 'bg-blue-500' : draft ? 'bg-yellow-600' : 'bg-gray-400' }}"></span>
                            </span>
                            <span
                                class="text-xs titlecase flex items-center {{ live ? 'text-red-500' : scheduled ? 'text-blue-500' : draft ? 'text-yellow-600' : 'text-gray-400' }}">
                                {{ item.quizStatus | quizStatusLabel }}
                            </span>
                        </div>
                    </div>

                    <!-- Right side: Ellipsis dropdown (only if owned by the logged in user) -->
                    @if (item.createdById === user?.uid) {
                    <div class="relative inline-block text-left">
                        <app-btn-fab bgColor="bg-transparent hover:bg-gray-200"
                            (click)="toggleDropdown($event, item.id)" icon="fas fa-ellipsis-vertical"></app-btn-fab>

                        <!-- Dropdown Panel -->
                        @if (activeDropdownQuizId() === item.id) {
                        <div
                            class="absolute right-0 z-50 w-44 origin-top-right rounded-lg bg-white border border-slate-200 shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none p-1">

                            <!-- Option 1: Close Quiz (Complete) -->
                            @if (item.quizStatus !== 'completed') {
                            <a (click)="$event.stopPropagation(); onCompleteQuiz(item)"
                                class="hover:bg-green-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent">
                                <i class="fa fa-circle-check text-emerald-500 mr-2 leading-relaxed"></i>
                                Close Quiz
                            </a>
                            }

                            <!-- Option 2: Cancel Quiz -->
                            @if (item.quizStatus !== 'cancelled') {
                            <a (click)="$event.stopPropagation(); onCancelQuiz(item)"
                                class="hover:bg-amber-200 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent"><i
                                    class="fa fa-ban mr-2 text-amber-500 leading-relaxed"></i>
                                Cancel Quiz
                            </a>
                            }

                            <!-- Option 3: Delete Quiz -->
                            <a (click)="$event.stopPropagation(); onDeleteQuiz(item)"
                                class="hover:bg-pink-100 cursor-pointer active:border-none text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent">
                                <i class="fa fa-trash-can mr-2 text-red-500 leading-relaxed"></i>
                                Delete Quiz
                            </a>
                        </div>
                        }
                    </div>
                    }
                </div>

                <!-- Second Row: Title and invite code -->
                <div class="flex flex-row flex-wrap justify-between items-center w-full">
                    <span class="text-sm font-semibold text-primary-500">{{ item.title }}</span>
                    @if (item.byInvite && item.inviteCode && (myRoles?.management || (myRoles?.faculty &&
                    item.createdById === user?.uid))) {
                    <div class="flex flex-row gap-1 justify-end items-center">
                        <span class="text-lg font-bold text-primary-500 text-right">{{ item.inviteCode }}</span>
                        <button (click)="$event.stopPropagation(); copyInviteCode(item.inviteCode)"
                            class="bg-transparent border-0 p-1 text-indigo-600 cursor-pointer hover:bg-slate-200 active:scale-95 transition-all duration-150 rounded-md inline-flex items-center justify-center"
                            title="Copy Invite Code">
                            <i class="far fa-copy text-xs"></i>
                        </button>
                    </div>
                    }
                </div>
            </div>
            }
            @empty {
            @if(group?.memberStatus === membershipStatus.active && (myRoles?.management || myRoles?.faculty)) {
            <div
                class="flex flex-col gap-1 bg-white py-8 px-4 mb-2 rounded-lg justify-center items-center border-gray-300">

                <i class="far fa-2x fa-circle-question text-primary-500 mb-2"></i>

                <span class="text-lg font-bold">Create Quiz</span>
                <span class="text-sm text-gray-700 text-center">Create quizzes to be taken at a later
                    time, or start a live quiz session</span>
                <div class="flex flex-row gap-4 items-center justify-around mt-1">
                    <app-btn-route routeTo="scheduleQuiz" colors="bg-gray-200 hover:bg-primary-500" padding="px-4 py-2"
                        textColor="text-primary-500 hover:text-white" textStyle="text-sm titlecase" [shadow]="false"
                        icon="fa fa-calendar-day" btnText="Schedule Quiz"></app-btn-route>
                    <app-btn-route routeTo="createLiveQuiz" colors="bg-gray-200 hover:bg-primary-500"
                        padding="px-4 py-2" textColor="text-primary-500 hover:text-white" textStyle="text-sm titlecase"
                        [shadow]="false" icon="fa fa-play" btnText="Live Quiz Room"></app-btn-route>
                </div>
            </div>
            }
            }
            @if (loadingQuizzes$ | async) {
            <div class="flex flex-row w-full items-center justify-center">
                <div class="animate-pulse min-h-14 w-full bg-gray-200 rounded-md"></div>
            </div>
            } @else {
            <div class="flex flex-row w-full items-center justify-center">
                <app-btn-more label="Show More" (click)="addMore()"></app-btn-more>
            </div>
            }
        </div>
    </div>
</div>